import { SellerItemUi } from '@/components/Seller/Table/SellerUi';
import { SellerResponse } from '@/data/api/model/sellers/SellersDto';
import {
  BadgeType,
  getGenericBadge,
  StatusBadgeUi,
} from '@/utils/statusBadges';

export const sellerResponseToSellerItemUi = (
  item: SellerResponse
): SellerItemUi => {
  return {
    id: item.business_id,
    sellerName: item.account_name,
    accountName: item.business_name,
    email: item.email,
    phone: item.phone,
    status: sellerStatusToStatusBadgeUi(item.business_status),
  };
};

export const sellerStatusToStatusBadgeUi = (
  status: string
): StatusBadgeUi | undefined => {
  switch (status) {
    case 'INACTIVE':
      return getGenericBadge(BadgeType.Warning, status, 'Inactivo');
    case 'ACTIVE':
      return getGenericBadge(BadgeType.Positive, status, 'Activo');
    default:
      return undefined;
  }
};
